import Application from '@ember/application';
import compatModules from '@embroider/virtual/compat-modules';
import loadInitializers from 'ember-load-initializers';
import Resolver from 'ember-resolver';
import config from './config/environment';
import logger from './lib/logger';

(window as any).define = function (
  _name: string,
  _deps: string,
  callback: () => void,
) {
  // Fallback for AMD modules.  Remove this once we are fully ESM.
  callback();
};

window.addEventListener('unhandledrejection', (event: any) => {
  try {
    if (event.reason) {
      logger.errorWithDetails(event.reason, { source: 'unhandledrejection' });
    }

    event.preventDefault();
  } catch {}
});

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver.withModules(compatModules);
}

loadInitializers(App, config.modulePrefix, compatModules);
